import { NgModule } from '@angular/core';
import { ButtonLoaderDirective } from './button-loader.directive';

@NgModule({
	declarations: [ButtonLoaderDirective],
	imports: [],
	exports: [ButtonLoaderDirective],
})
export class ButtonLoaderModule {}
